import { useEffect, useState } from 'react'
import cx from 'classnames'
import axios from 'axios'
import { TrashIcon } from '@heroicons/react/outline'

import { Button, Text } from 'components/atomic'
import { useUserMetaSubscription as useUserMetadataSubscription } from 'generated/graphql'
import TwitterIcon from '../../../../public/images/onboarding/social-twitter.svg'
import SteamIcon from '../../../../public/images/onboarding/social-steam.svg'
import DiscordIcon from '../../../../public/images/onboarding/social-discord.svg'
import TwitchIcon from '../../../../public/images/onboarding/social-twitch.svg'
import YoutubeIcon from '../../../../public/images/onboarding/social-youtube.svg'
import styles from './index.module.scss'

const SocialAccounts = {
  twitter: { icon: TwitterIcon, authUrl: '/api/auth/twitter', label: 'Twitter' },
  steam: { icon: SteamIcon, authUrl: '/api/auth/steam', label: 'Steam' },
  discord: { icon: DiscordIcon, authUrl: '/api/auth/discord', label: 'Discord' },
  twitch: { icon: TwitchIcon, authUrl: '/api/auth/twitch', label: 'Twitch' },
  youtube: { icon: YoutubeIcon, authUrl: '/api/auth/youtube', label: 'Youtube Chan' },
}

const SocialAccountItem = ({ metadata, metaKey, icon: SocialIcon, authUrl, label, isSmallScreen }) => {
  const accountName = metadata[metaKey]?.length > 14 ? `${metadata[metaKey].slice(0, 14)}...` : metadata[metaKey]
  const isConnected = !!accountName

  const [isDisconnectLoading, setIsDisconnectLoading] = useState<boolean>(false)

  const openAuthPopup = () => {
    window.open(authUrl, '_blank', 'location=yes,height=672,width=520,status=yes')
  }

  const handleDisconnectSocial = async () => {
    try {
      setIsDisconnectLoading(true)
      await axios.get(`/api/disconnect-social?network=${metaKey}`)
    } catch (error) {
    } finally {
      setIsDisconnectLoading(false)
    }
  }

  // to disable YT in SocialIcon: ${label === 'Youtube Chan' && 'text-black'}
  return (
    <div className={`mb-10 ${isSmallScreen ? 'w-full 2lg:w-11/12' : 'w-full lg:w-[310px]'}`}>
      <div className={cx(isConnected ? 'text-secondary' : 'text-white', 'mx-4 mb-2.5 flex h-7 items-end')}>
        <SocialIcon className={`mr-2 pt-1 h-6 w-5`} transform="scale(1.3)" />
        <Text tag="span" variant="body2" className="mr-auto uppercase">
          {isConnected ? `${label} linked` : `connect ${label}`}
        </Text>
      </div>

      <Button
        variant={isConnected ? 'primary' : 'secondary'}
        onClick={isConnected ? handleDisconnectSocial : openAuthPopup}
        className="md:w-full"
        state={isDisconnectLoading ? 'disabled' : ''}
      >
        <div
          className={cx(
            'flex w-full items-center',
            isDisconnectLoading ? 'justify-center' : isConnected ? 'justify-between' : 'justify-center',
          )}
        >
          {isDisconnectLoading ? (
            <div className={styles.loader} />
          ) : (
            <>
              <span>{isConnected ? accountName : '-'}</span>
              {isConnected && (
                <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-black">
                  <TrashIcon className="button_icon w-5 text-secondary" />
                </span>
              )}
            </>
          )}
        </div>
      </Button>
    </div>
  )
}

interface SocialConnectionProps {
  isSmallScreen?: boolean
}
export default function SocialConnection({ isSmallScreen }: SocialConnectionProps) {
  const { data } = useUserMetadataSubscription()
  const [metadata, setMetadata] = useState({})

  // // NOTE: need nhostRefreshToken in cookie after login, for server api access
  // useEffect(() => {
  //   if (localStorage?.getItem?.('nhostRefreshToken')) {
  //     const exdate = new Date()
  //     exdate.setDate(exdate.getDate() + 30)
  //     document.cookie =
  //       'nhostRefreshToken=' +
  //       escape(localStorage.getItem('nhostRefreshToken') || '') +
  //       '; expires=' +
  //       exdate.toUTCString() +
  //       '; path=/'
  //   }
  // }, [])

  useEffect(() => {
    const response = data?.users_metadata[0]
    if (response) {
      setMetadata(response)
    }
  }, [data])

  return (
    <>
      {Object.entries(SocialAccounts).map(([key, attrs]) => (
        <SocialAccountItem key={key} metaKey={key} {...attrs} metadata={metadata} isSmallScreen={isSmallScreen} />
      ))}
    </>
  )
}
